import { render, staticRenderFns } from "./PriceList.vue?vue&type=template&id=1406c014&scoped=true&"
import script from "./PriceList.vue?vue&type=script&lang=ts&"
export * from "./PriceList.vue?vue&type=script&lang=ts&"
import style0 from "./PriceList.vue?vue&type=style&index=0&id=1406c014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1406c014",
  null
  
)

export default component.exports